import React from "react";
import apiRequest from "../../../utils/admin/apiRequest";
import Alert from "../../ui/utils/Alert";
import Button from "../../ui/utils/Button";
import usePost from "../../../hooks/api/usePost";

const DeleteExcel = ({ closeModal, callback, data }) => {
  const { error, isLoading: loading, post } = usePost(apiRequest.deleteExcel);

  const handleDelete = async () => {
    try {
      const response = await post({ data: { id: data?._id } });
      if (response?.response) {
        callback?.();
        closeModal();
      }
    } catch (_) {}
  };

  return (
    <div className="p-4 text-sm">
      {error && <Alert message={error} type={"error"} />}
      <p className="mb-4">
        Are you sure you want to delete the excel {" "}
        <span className="font-semibold">{data?.name}</span>?
      </p>
      <div className="flex justify-end gap-2">
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          variant="danger"
          loadingText="Deleting..."
          isLoading={loading}
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default DeleteExcel;
